module.exports = __webpack_public_path__ + "static/media/James-wong-twitter.d872df24.jpg";